/* Buddies header package: rotating search hint, Shop button label, logo resolution */
(function () {
  'use strict';
  if (window.__buddiesHeader) return;
  window.__buddiesHeader = true;

  var PHRASES = ['Search beds…', 'Search harnesses…', 'Search toys…', 'Search cat trees…', 'Search grooming…'];
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Rotating search placeholder ---- */
  function setupSearch(input) {
    if (input.hasAttribute('data-bh-rotate')) return;
    input.setAttribute('data-bh-rotate', '');
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Search');
    var original = input.getAttribute('placeholder') || 'Search';
    // the theme shows a floating <label> over the field (placeholder is transparent),
    // so rotate the label's visible text; the input's aria-label keeps the name "Search"
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var labelText = label ? label.textContent : '';
    var i = 0;
    var timer = null;
    function show(text) {
      input.setAttribute('placeholder', text);
      if (label) label.textContent = text;
    }
    function tick() {
      if (document.activeElement === input || input.value) return;
      show(PHRASES[i % PHRASES.length]);
      i++;
    }
    function start() {
      if (timer || reduced.matches) return;
      timer = setInterval(tick, 3000);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
      input.setAttribute('placeholder', original);
      if (label) label.textContent = labelText;
    }
    input.addEventListener('focus', stop);
    input.addEventListener('input', function () { if (input.value) stop(); });
    input.addEventListener('blur', function () { if (!input.value) start(); });
    if (reduced.addEventListener) {
      reduced.addEventListener('change', function () {
        if (reduced.matches) { stop(); } else { start(); }
      });
    }
    start();
  }

  /* ---- Shop pill accessible name ---- */
  function setupShopButton() {
    var s = document.querySelector('.header__mobile header-drawer > details > summary');
    if (s && !s.getAttribute('aria-label')) s.setAttribute('aria-label', 'Shop');
  }

  /* ---- Logo: request a source sized for the larger display width ---- */
  function upgradeLogos() {
    document.querySelectorAll('.section-header .header__heading-logo[srcset]').forEach(function (img) {
      if (img.hasAttribute('data-bh-logo')) return;
      img.setAttribute('data-bh-logo', '');
      var target = img.closest('.header__mobile') ? 190 : 300;
      var set = img.getAttribute('srcset');
      if (!/width=\d+/.test(set)) return;
      var next = set
        .replace(/width=\d+(\S*)\s+1x/, 'width=' + target + '$1 1x')
        .replace(/width=\d+(\S*)\s+2x/, 'width=' + (target * 2) + '$1 2x');
      if (next !== set) img.setAttribute('srcset', next);
    });
  }

  function init() {
    document.querySelectorAll('.section-header input[type="search"][name="q"]').forEach(setupSearch);
    setupShopButton();
    upgradeLogos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
